import React, { Component, Fragment } from 'react'
import {
  ButtonPrimary, Frame, SpacerVertical, Stepper, Typography, View
} from '@klarna/bubble-ui'
import { FallbackContent, getFallbackContent } from './fallbackContent'
import Layout from '../../Layout/Layout'
import config from '../../../config'

interface FallbackState {
  content: FallbackContent
  footerButtons: any
  backgroundThemeKey: string
}

interface FallbackProps {
  theme: 'dark' | 'default'
  onClose: () => void
  country?: string
  language?: string
}

class Fallback extends Component<FallbackProps, FallbackState> {
  constructor(props: FallbackProps) {
    super(props)

    const backgroundThemeKey = this.props.theme === 'dark' ? 'darkBackgroundTheme' : 'backgroundTheme'
    const footerButtons: any = this.props.onClose ? [{
      Component: ButtonPrimary,
      props: {
        children: 'Close',
        id: 'error-close-button',
        onClick: () => {
          this.props.onClose()
        }
      }
    }] : []
    this.state = { footerButtons, backgroundThemeKey, content: null }
  }

  componentDidMount(): void {
    getFallbackContent(this.props.country, this.props.language).then(content => this.setState({ ...this.state, content }))
  }

  renderFooterButton(footerButtons: any): unknown {
    const newFooterButtons = footerButtons.map((button: any) => (
      {
        ...button,
        props: {
          ...button.props,
          children: this.state.content.close || 'Close'
        }
      }
    ))

    return newFooterButtons
  }

  render() {
    return this.state.content && (
      <Layout {...this.props} bespokeId='fallback' footerButtons={this.renderFooterButton(this.state.footerButtons)}>
        <Fragment>
          <Typography id="learn-more-title" textAlignToken="text-alignment/center" textToken='text-style/headings/titles/bold/quaternary'>
            {this.state.content.title}
          </Typography>
          <SpacerVertical spaceToken="space.100" />
          <Typography
            id="learn-more-sub-title"
            textAlignToken="text-alignment/center"
            textToken='text-style/text/super-paragraphs/default/regular'>
            {this.state.content.subTitle}
          </Typography>

          <SpacerVertical spaceToken="space.400" />
          <Typography id="timeline-header" textAlignToken="text-alignment/center" textToken='text-style/headings/titles/bold/quaternary'>
            {this.state.content.timelineHeader}
          </Typography>

          <SpacerVertical spaceToken="space.200" />
          <Frame backgroundColorToken={config[this.state.backgroundThemeKey].frame_component}>
            <View>
              <SpacerVertical spaceToken="space.200" />
              <Stepper>
                {this.state.content.timelineItems.map((entry, index) => (
                  <Stepper.Item key={index} title={entry.title} description={entry.description} />
                ))}
              </Stepper>
            </View>
          </Frame>
        </Fragment>
      </Layout>
    )
  }
}

export default Fallback
